import { TextVariableOptions } from '@gift/text-core/TextVariableOptions';
import { TextVariableInput } from '@gift/text-core/TextVariableInput';
import { createInputBindings } from '@gift/website-state/slices/inputsSlice';
import { createOptionBindings } from '@gift/website-state/slices/variablesSlice';

const { createInputSelector, createInputUpdater }
    = createInputBindings<TextVariableInput>();

export const selectContentById = createInputSelector(i => i.content);
export const updateContentByIds = createInputUpdater('content');

export const selectFontFamilyById = createInputSelector(i => i.fontFamily);
export const updateFontFamilyByIds = createInputUpdater('fontFamily');

export const selectFontWeightById = createInputSelector(i => i.fontWeight);
export const updateFontWeightsByIds = createInputUpdater('fontWeight');

export const selectFontStyleById = createInputSelector(i => i.fontStyle);
export const updateFontStyleByIds = createInputUpdater('fontStyle');

export const selectUnderlineById = createInputSelector(i => i.underline);
export const updateUnderlineByIds = createInputUpdater('underline');

const { createOptionSelector } = createOptionBindings<TextVariableOptions>();

export const selectMaxLengthById = createOptionSelector(o => o.maxLength);